export default (isMobile) => ({
  container: {
    height: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#F8F9FA",
    overflow: "hidden",
  },

  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    gap: 2,
  },

  loadingText: {
    color: "#666",
    fontSize: "16px",
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "24px 32px",
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #E5E7EB",
    flexShrink: 0,
  },

  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: 2,
  },

  backButton: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "#F3F4F6",
    "&:hover": {
      backgroundColor: "#E5E7EB",
    },
  },

  title: {
    fontSize: "24px",
    fontWeight: 600,
    color: "#111827",
    marginBottom: "4px",
  },

  subtitle: {
    fontSize: "14px",
    color: "#6B7280",
  },

  headerActions: {
    display: "flex",
    gap: 2,
  },

  actionButton: {
    fontSize: "14px",
    fontWeight: 600,
    padding: "8px 16px",
    borderRadius: "8px",
    textTransform: "none",
  },

  summaryCardsContainer: {
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "repeat(4, 1fr)",
    gap: "16px",
    padding: "1vh 2vw",
    backgroundColor: "#fff",
  },

  summaryCard: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #E5E7EB",
    boxShadow: "none",
  },

  summaryCardContent: {
    padding: "20px",
  },

  summaryCardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  summaryCardLabel: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#6B7280",
    marginBottom: "8px",
  },

  summaryCardValue: {
    fontSize: "24px",
    fontWeight: 700,
    color: "#111827",
  },

  summaryCardIcon: {
    width: "40px",
    height: "40px",
    borderRadius: "8px",
    backgroundColor: "#EFF6FF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
  },

  tabsContainer: {
    padding: "2vh 2vw",
    backgroundColor: "#ff",
  },

  tabContent: {
    flex: 1,
    padding: "0 2vw",
    marginBottom: "2vh",
    backgroundColor: "#fff",
    overflow: "auto",
  },

  itemBreakdownContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },

  inclusionCard: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #E5E7EB",
    boxShadow: "none",
  },

  inclusionCardContent: {
    padding: "24px",
  },

  inclusionHeader: {
    marginBottom: "20px",
  },

  inclusionTitleContainer: {
    display: "flex",
    alignItems: "center",
    gap: 2,
  },

  inclusionIcon: {
    fontSize: "20px",
  },

  inclusionTitle: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#111827",
  },

  boqsContainer: {
    marginTop: "16px",
  },

  boqsList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },

  boqItem: {
    backgroundColor: "#F9FAFB",
    borderRadius: "8px",
    border: "1px solid #E5E7EB",
    padding: "16px",
  },

  boqItemContent: {
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "1.2fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr",
    gap: "16px",
    alignItems: "center",
  },

  boqImageNameContainer: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minWidth: 0,
  },

  boqImageContainer: {
    width: "48px",
    height: "48px",
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: "#E5E7EB",
    flexShrink: 0,
    position: "relative",
  },

  boqImagePlaceholder: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#E5E7EB",
  },

  boqNameContainer: {
    minWidth: 0,
  },

  boqItemName: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#111827",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  boqDetailColumn: {
    textAlign: isMobile ? "left" : "center",
    minWidth: 0,
  },

  boqDetailLabel: {
    fontSize: "12px",
    color: "#6B7280",
    marginBottom: "4px",
    display: "block",
  },

  boqDetailValue: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#111827",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  noBoqsContainer: {
    textAlign: "center",
    padding: "32px",
  },

  noBoqsText: {
    color: "#6B7280",
  },

  emptyStateCard: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #E5E7EB",
    boxShadow: "none",
  },

  emptyStateContent: {
    textAlign: "center",
    padding: "48px",
  },

  emptyStateText: {
    color: "#6B7280",
  },

  costSummaryCard: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #E5E7EB",
    boxShadow: "none",
  },

  costSummaryContent: {
    textAlign: "center",
    padding: "48px",
  },

  costSummaryIconContainer: {
    marginBottom: "16px",
  },

  costSummaryIcon: {
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    backgroundColor: "#FEF3C7",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "24px",
    margin: "0 auto",
  },

  costSummaryTitle: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#111827",
    marginBottom: "8px",
  },

  costSummarySubtitle: {
    fontSize: "14px",
    color: "#6B7280",
  },
});
